import lengthEndAdornment from "constants/lenghtEndAdornment";
import CreateProductAttributesFormFields from "./CreateProductAttributesFormFields";

const fields = [];

export default function SlurrySealForm() {
  return <CreateProductAttributesFormFields fields={fields} />;
}
